<template>
      <el-drawer
        title="本地仓库"
        :visible.sync="drawer"
        size="90%"
        :before-close="handleClose"
        @open="handleOpen"
        >
        <div style="padding: 10px">
            <div>
                <span>库存</span>
                <span style="margin-left: 5px;">一天卡：{{ oneMax }}张</span>
                <span style="margin-left: 5px;">两天卡：{{ twoMax }}张</span>
                <span style="margin-left: 5px;">三天卡：{{ threeMax }}张</span>
            </div>
          <div class="check">
            <el-button style="margin-left: 20px"  type="primary" @click="dialogVisible=true">提卡 </el-button>
            <el-tooltip class="item" effect="dark" content="尽量少更新，重复查包可能会导致掉包率增加" placement="top">
                <el-button style="margin-left: 20px"  type="primary" @click="updateData">从爱奇艺服务器更新 </el-button>
            </el-tooltip>
            <!-- <el-button
              style="margin-left: 20px"
              type="primary"
              @click="createdXlsx"
              :disabled="loading"
              >
            </el-button> -->
           
         </div>
          <el-table :data="localData" style="width: 100%" >
          <el-table-column prop="link" label="链接"> </el-table-column>
          <el-table-column prop="day" label="剩余天数">
            <template slot-scope="scope">
              <span v-if="scope.row.day > 5">剩余{{ scope.row.day }}天</span>
              <span v-else-if="scope.row.day >= 0 && scope.row.day <= 5"
                >临期-{{ scope.row.day }}天</span
              >
              <span v-else class="red">过期</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="预测" width="180">
          </el-table-column>
          <el-table-column prop="receivedNum" label="已领数量" width="180">
          </el-table-column>
          <el-table-column prop="surplusNum" label="剩余数量"> </el-table-column>
          <el-table-column prop="totalNum" label="总数量"> </el-table-column>
        </el-table>
        </div>
        <el-dialog
            :modal="false"
            title="提卡类型"
            :visible.sync="dialogVisible"
            width="30%"
           >
           <el-input  class="order" v-model="num" placeholder="数量" ></el-input>
            <el-select style="width: 100%;margin-top: 10px;" v-model="litterType" placeholder="请选择">
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="litter">确 定</el-button>
            </span>
        </el-dialog>
      </el-drawer>
  </template>
  
  <script>
  import * as XLSX from '../xlsx.full.min.js';
  
  export default {
    name: "App",
    data() {
      return {
        predictDayResult:[],
        drawer:false,
        localData:[],
        dialogVisible:false,
        litterType:'',
        num:null,
        options: [{
          value: 'one',
          label: '一天卡'
        }, {
          value: 'two',
          label: '两天卡'
        }, {
          value: 'three',
          label: '三天卡'
        }],
      };
    },
    computed: {
      surplusDay(){
        return function(deadline){
          const timestamp = new Date().getTime();
         return  Math.floor((deadline - timestamp) / 1000 / 60 / 60 / 24)
        }
      },
      oneMax(){
        return this.localData.filter(item=>item.type=='one').length
      },
      twoMax(){
        return this.localData.filter(item=>item.type=='two').length
      },
      threeMax(){
        return this.localData.filter(item=>item.type=='three').length
      }
    },
    created() {
        
    },
    methods: {
        async updateData(){
           this.$parent.input = this.localData.map(item=>item.link).join('\n');
           const success = await this.$parent.getLinkInfo()
           if(success) this.$parent.saveLocal()
           this.handleOpen()

        },
        handleOpen(){
            this.localData = JSON.parse(window.localStorage.getItem('aqyData'))||[]
            this.localData.forEach(item=>item.day = this.surplusDay(item.deadline))
        },
        handleClose(){
            this.localData = this.localData.filter(item=>item.receivedNum<item.totalNum)
            window.localStorage.setItem('aqyData',JSON.stringify(this.localData))
            this.drawer = false
        },
        getName(day){
            if(day==1) return '一天卡'
            else if(day==2) return '两天卡'
            else return '三天卡'
        },
        getType(day){
            if(day==1) return 'one'
            else if(day==2) return 'two'
            else return 'three'
        },
        litter(){
            if(this.num===0) return
            const max = this.localData.filter(item=>item.type==this.litterType).length
            if(this.num>max){
                this.$message({
                    type: 'warning',
                    message: '库存不足'
                });
                return
            }
            this.$confirm('提卡之后将默认领取一个包,只剩最后一个包会直接从仓库删除,是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
            }).then(() => {
                const litterData =[{link:'',name:''}]
                this.localData.forEach(item=>{
                const {type,link,name,law} = item
                if(type==this.litterType){
                    litterData.push({
                        link,name
                    })
                    item.receivedNum++;
                    item.surplusNum--;
                    item.type = this.getType(law[item.receivedNum])
                    item.name = this.getName(law[item.receivedNum])
                }
            })
            const curLabel = this.options.find(item=>item.value ==this.litterType ).label
            const workbook = XLSX.utils.book_new();
            this.generatePredictTable(litterData,workbook,curLabel)
            XLSX.writeFile(workbook, `${curLabel}-${new Date().getTime()}.xlsx`, { compression: true });
            this.localData = this.localData.filter(item=>item.receivedNum<item.totalNum)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消提卡'
                });
            });
           this.dialogVisible = false
        },
        generatePredictTable(links,workbook,lv){
            const utils = XLSX.utils;
            const sheetOpts = {
                header:['link','name']
            }
            const titles = ["链接", "预测"]
            const sheet = utils.json_to_sheet(links,sheetOpts);
            utils.book_append_sheet(workbook, sheet, lv);
            utils.sheet_add_aoa(sheet, [[`此表为${lv}，已经领完、过期的红包自动剔除，预测仅供参考`,,]], { origin: "A1" });
            utils.sheet_add_aoa(sheet, [titles], { origin: "A2" });
            sheet["!cols"]=[ { wch: 118 } ];
            sheet["!merges"] = [XLSX.utils.decode_range("A1:G1")];
        },
  
    }
  };
  </script>
  
  <style>

  .check {
    display: flex;
    margin-bottom: 30px;
  }
  #app .liukou-info {
    display: flex;
  }
  .liukou-info .order {
    margin-right: 20px;
  }
  .red {
    color: red;
  }
  .info {
    margin-bottom: 20px;
  }
  .info .el-tag{
    cursor: pointer;
  }
  </style>
  


// WEBPACK FOOTER //
// src/Storehouse.vue